import axiosPrivate from "../../../api/axiosPrivate";
import { APPROVE_SAVINGS_CLAIM, CREATE_SAVINGS_CLAIM, DECLINE_SAVINGS_CLAIM, GET_ALL_SAVINGS_CLAIM, GET_SAVINGS_CLAIM_DETAILS, GET_SAVINGS_POLICYHOLDER, GET_SINGLE_SAVINGS_CLAIM, UPDATE_SAVINGS_CLAIM } from "../../../api/constant";


const getSavingsPolicyHolder = async ({ office_id, policy_app_number }) => {
    const response = await axiosPrivate.get(
      `${GET_SAVINGS_POLICYHOLDER}?office_id=${office_id}&policy_app_number=${policy_app_number}`
    );
    return response.data;
};
const getSavingsClaimDetails = async ({ policy_application_number, claim_category, claim_type, policy_id, customer_id, amount_payable }) => {
    const response = await axiosPrivate.get(
      `${GET_SAVINGS_CLAIM_DETAILS}?policy_application_number=${policy_application_number}&claim_category=${claim_category}&claim_type=${claim_type}&policy_id=${policy_id}&customer_id=${customer_id}&amount_payable=${amount_payable}`
    );
    return response.data;
};
const createSavingsClaim = async (data) => {
  const response = await axiosPrivate.post(`${CREATE_SAVINGS_CLAIM}`, data);
  return response.data;
};
const getSavingsClaims = async ({ office_id, search, pageNumber }) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_SAVINGS_CLAIM}?office_id=${office_id}&search=${search}&page=${pageNumber}`
  );
  return response.data;
};
const getSingleClaim = async ({claim_type, claim_category, claim_id, policy_application_number, customer_id}) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_SAVINGS_CLAIM}?claim_type=${claim_type}&claim_category=${claim_category}&claim_id=${claim_id}&policy_application_number=${policy_application_number}&customer_id=${customer_id}`
  );
  return response.data;
};
const updateSavingsClaim = async (data) => {
  const response = await axiosPrivate.post(UPDATE_SAVINGS_CLAIM, data);
  return response.data;
};
const approveClaim = async (data) => {
  const response = await axiosPrivate.post(APPROVE_SAVINGS_CLAIM, data);
  return response.data;
};
const declineClaim = async (data) => {
  const response = await axiosPrivate.post(DECLINE_SAVINGS_CLAIM, data);
  return response.data;
};


const savingsClaimService = {
    getSavingsPolicyHolder,
    getSavingsClaimDetails,
    createSavingsClaim,
    getSavingsClaims,
    getSingleClaim,
    updateSavingsClaim,
    approveClaim,
    declineClaim
} 

export default savingsClaimService;